module.exports = __webpack_public_path__ + "img/05.6633e6ed.png";